<script>
    import {onMount} from 'svelte';
    import { on } from 'svelte/events'
    export let settingsOpen = false;

    let _ui = ui;

    onMount(async () => {
        if (localStorage.getItem('theme') != null) {
            await _ui("theme", localStorage.getItem('theme'));
        } else {
            await _ui("theme", '#166F42');
        }

        if (localStorage.getItem('colorMode') != null) {
            let colorMode = localStorage.getItem('colorMode')
            await _ui("mode", colorMode);
        }
        
    })

    function changeExtraCats() {
        if (extraCats) {
            localStorage.setItem('extraCats','Y')
        } else {
            localStorage.setItem('extraCats','N')
        }
    }

    async function theme(color) {
        localStorage.setItem('theme',color)
        await _ui("theme", color);
    }
    
</script>

{#if settingsOpen}
    <dialog class="large-width active" id="themes3" open="">
        <header class="fixed">
            <nav>
                <div class="max">
                    <h5>
                        <span>Settings</span>

                    </h5>
                </div>
                <button on:click={() => settingsOpen = false} class="circle transparent" data-ui="#themes3"
                    ><i>close</i></button
                >
            </nav>
            <div class="left-align">
                <h6 class="small">
                    <span>Colors</span>

                </h6>
            </div>            
            <nav class="wrap">
                <button on:click={() => theme('#f44336')} class="circle small red"></button>
                <button on:click={() => theme('#e91e63')} class="circle small pink"></button>
                <button on:click={() => theme('#9c27b0')} class="circle small purple"></button>
                <button on:click={() => theme('#673ab7')} class="circle small deep-purple"></button>
                <button on:click={() => theme('#3f51b5')} class="circle small indigo"></button>
                <button on:click={() => theme('#2196f3')} class="circle small blue"></button>
                <button on:click={() => theme('#03a9f4')} class="circle small light-blue"></button>
                <button on:click={() => theme('#00bcd4')} class="circle small cyan"></button>
                <button on:click={() => theme('#009688')} class="circle small teal"></button>
                <button on:click={() => theme('#166F42')} class="circle small" style="background-color: #166F42;"></button>
                <button on:click={() => theme('#8bc34a')} class="circle small light-green"></button>
                <button on:click={() => theme('#cddc39')} class="circle small lime"></button>
                <button on:click={() => theme('#ffeb3b')} class="circle small yellow"></button>
                <button on:click={() => theme('#ffc107')} class="circle small amber"></button>
                <button on:click={() => theme('#ff9800')} class="circle small orange"></button>
                <button on:click={() => theme('#ff5722')} class="circle small deep-orange"></button>
                <button on:click={() => theme('#795548')} class="circle small brown"></button>
                <button on:click={() => theme('#9e9e9e')} class="circle small grey"></button>
                <button on:click={() => theme('#607d8b')} class="circle small blue-grey"></button>
                <button on:click={() => theme('#000000')} class="circle small black"></button>
                <button on:click={() => theme('#ffffff')} class="circle small white"></button>
            </nav>
        </header>
        <div class="space">
        </div>          
    </dialog>
{/if}